import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormNumberInput } from '@/_components';

import { type RelationshipScoreFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<RelationshipScoreFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="label"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Relationship Score (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="number"
        render={({ field }) => (
          <FormNumberInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Score"
            {...field}
            disabled={!isEditable}
            value={field.value}
            onValueChange={(s) => {
              field.onChange(s.value);
            }}
          />
        )}
      />
    </>
  );
}
